<script>
    import FrameUI from '$lib/components/layout/FrameUI.svelte'
    import * as icons from '../assets/pictures'
    import { Typography, Button } from '$lib/components/UI'
    import { navigate, useLocation } from 'svelte-navigator'
    import Redirect from '$lib/components/layout/Redirect.svelte'
    const location = useLocation()
    const tpStyle = 'margin: 0; padding: 0; text-align: center'
</script>

{#if $location.state}
    {@const {
        buttonSet = [],
        title = null,
        icon = '',
        desc = null,
        postdata = null,
    } = $location.state}
    <FrameUI background="grey" isOpen={false}>
        <div class="main">
            <div class="box verticalAlign">
                <img
                    draggable="false"
                    width="60px"
                    height="60px"
                    src={icons[icon]}
                    alt=""
                />
                <Typography style={tpStyle} type="h4">{title}</Typography>
                {#if desc}
                    <Typography color="grey-800" style={tpStyle} type="body"
                        >{@html desc}</Typography
                    >
                {/if}
                {#if buttonSet.length > 0}
                    <span class="buttonSet">
                        {#each buttonSet as { navTo = null, ...button }}
                            <Button
                                on:click={(_) => {
                                    if (navTo) {
                                        navigate(navTo)
                                    }
                                }}
                                {...button}
                            />
                        {/each}
                    </span>
                {/if}
            </div>
            {#if postdata}
                <div class="postdata verticalalign">
                    {@html postdata}
                </div>
            {/if}
        </div>
    </FrameUI>
{:else}
    <Redirect path="/" />
{/if}

<style>
    .main {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        position: relative;
        padding: 61px 0 120px 0;
    }

    .verticalAlign {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .box {
        width: 200px;
        padding: 40px 80px;
        gap: 14px;
        width: 45%;
        min-width: 500px;
        max-width: 800px;
        background: #ffffff;
        border: 1px solid #ebebeb;
        border-radius: 8px;
    }
    .buttonSet {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        gap: 14px;
    }

    .postdata {
        display: flex;
        position: relative;
        flex-direction: column;
        padding: 36px 0 0 0;
        gap: 8px;
        color: var(--color-grey-800);
        width: 500px;
        /* max-width: 431px; */
        text-align: center;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
    }
</style>
